import { DatePicker, Form } from "antd";
import { title } from "process";
import React from "react";

import { FIELD_TYPE } from "types/enums";
import { ColumnsEdit } from "types/models/column-table-edit";
import { DataFormField } from "types/models/input-field-type";

const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER } = FIELD_TYPE;

const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}

//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2020;
const endYear = currentYear + 100;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}
//--------------------------------------------

//----------------------------------------------

const allColumns: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    show: true,
    dataIndex: "stt",
    fixed: "left",
    width: 40,
    // onCell: (record: { flag: number }, i: number) => ({
    //   rowSpan: record.flag % 3 === 0 ? 3 : 0,
    //   colSpan: i > 2 ? 2 : 1,
    // }),
    onCell: (record, i) => ({
      colSpan: i > 2 ? 2 : 1,
      rowSpan: i % 3 === 0 ? 3 : 0,
    }),
    isResizable: true,
  },
  {
    title: "Mã NV",
    key: "maNhanVien",
    show: true,
    fixed: "left",
    dataIndex: "maNhanVien",
    width: 80,
    align: "left",
    isResizable: true,
    // onCell: (record: { flag: number }, i) => ({
    //   rowSpan: record.flag % 3 === 0 ? 3 : 0,
    //   colSpan: i > 2 ? 2 : 1,
    // }),
    onCell: (record, i) => ({
      colSpan: i > 2 ? 2 : 1,
      rowSpan: i % 3 === 0 ? 3 : 0,

    }),
  },
  {
    title: "Họ tên",
    key: "hoTen",
    show: true,
    dataIndex: "hoTen",
    width: 150,
    align: "left",
    fixed:"left",
    // onCell: (record: { flag: number }, i) => {

    //   return {
    //     rowSpan: record.flag % 3 === 0 ? 3 : 0,
    //     colSpan: i > 2 ? 2 : 1,
    //   };
    // },
    isResizable: true,
    onCell: (record, i) => ({
      colSpan: i > 2 ? 2 : 1,
      rowSpan: i % 3 === 0 ? 3 : 0,

    }),
  },
  {
    title:'Thang',
    show: true,
    dataIndex: "thang",
    align: "center",
  },
];

const itemsInputField: DataFormField[] = [
  // {
  //   type: COMBO_BOX,
  //   label: "Phòng",
  //   name: "idPhongBan",
  //   disable: false,
  // },
  {
    type: INPUT,
    label: "Mã NV",
    name: "maNhanVien",
    disable: false,
  },
  {
    type: INPUT,
    label: "Họ tên",
    name: "hoTen",
    disable: false,
  },
  {
    type: COMBO_BOX,
    name: "thang",
    label: "Tháng",
    disable: false,
    options: listMonths,
    rules: [{ message: "Bạn chưa chọn tháng", required: true }],
  },
  {
    type: COMBO_BOX,
    name: "nam",
    label: "Năm",
    disable: false,
    options: listYears,
    rules: [{ message: "Bạn chưa chọn năm", required: true }],
  },
];

export { allColumns, itemsInputField, listYears };
